<template>
  <div class="checkbox-column">
    <div class="luomu">
      <label class="b-contain" :class="{ disabled: loading }">
        <span>Soveltuu luomuviljelyyn</span>
        <input v-model="eco" type="checkbox" :disabled="loading" />
        <div class="b-input"></div>
      </label>
    </div>
    <div class="winter">
      <label class="b-contain" :class="{ disabled: loading }">
        <span>Soveltuu talvikalkitukseen</span>
        <input v-model="winter" type="checkbox" :disabled="loading" />
        <div class="b-input"></div>
      </label>
    </div>
  </div>
</template>

<script>
import { UPDATE_ECO_FILTER, UPDATE_WINTER_FILTER } from "../../store/constants";
import { mapMutations } from "vuex";

export default {
  name: "CheckBoxColumn",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    winter: {
      get() {
        return this.$store.state.product_filters.winter;
      },
      set(value) {
        this.updateWinterFilter(value);
      },
    },
    eco: {
      get() {
        return this.$store.state.product_filters.eco;
      },
      set(value) {
        this.updateEcoFilter(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      updateWinterFilter: UPDATE_WINTER_FILTER,
      updateEcoFilter: UPDATE_ECO_FILTER,
    }),
  },
};
</script>

<style lang="scss" scoped>
.checkbox-column {
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  .b-contain.disabled {
    cursor: not-allowed;
  }
  input {
    &:disabled {
      cursor: not-allowed;
    }
  }
}
</style>
